import * as React from 'react';

import '../../styles/App.css';
import vodafoneIcon from '../../assets/img/vodafoneIcon.svg';

export default function Navbar() {
  return (
    <div className="main-nav">
      <div className="content">
        <img src={vodafoneIcon} className="logo" alt="logo" />
      </div>
    </div>
  )
}